import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { getPageProperty, PolotnoStoreActivePageKeys } from '@/pages/AdvancedEditor/hooks';
import { UnlockItem } from '../options/UnlockItem';

export const UnlockContextualMenu = () => {
    const { store } = useAdvancedEditorContext();

    const isThereAnySelectedLockedElement = getPageProperty(store.activePage, PolotnoStoreActivePageKeys.isThereAnySelectedLockedElement);

    return isThereAnySelectedLockedElement ? <UnlockItem /> : null;
};
